import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import { formattedToReadable } from 'uplisting-frontend/utils/string';

const reasonBase = 'DECLINE_REASON_HOST_';

export default class ReadableCancellationReason extends Helper {
  @service intl!: Services['intl'];

  compute([reason]: [string]): string {
    if (this.intl.exists(`airbnb_cancellation_reasons.${reason}`)) {
      return this.intl.t(`airbnb_cancellation_reasons.${reason}`);
    }

    let result = reason;

    if (result.startsWith(reasonBase)) {
      result = reason.slice(reasonBase.length);
    }

    return formattedToReadable(result);
  }
}
